/** Focus that never throws (detached nodes, inert subtrees, jsdom). */
export function safeFocus(
  el: HTMLElement | null | undefined,
  options?: FocusOptions,
): void {
  try {
    el?.focus(options);
  } catch {
    /* ignore */
  }
}
